import SentBatchDetail from '@/components/messaging/sent/SentBatchDetail';

const SentBatchDetailPage = () => {
  return <SentBatchDetail />;
};

export default SentBatchDetailPage;
